<template>
  <div class="box" flex-1>
    <el-card class="box-card" flexContainer :body-style="{ padding: '0 30px' }">
      <div class="header">
        <div class="menuselect">
          <p>角色显示&nbsp;</p>
          <el-select v-model="value" placeholder="请选择" size="small" @change="select(value)">
            <el-option :value="'全部'">全部</el-option>
            <el-option
              v-for="item in options"
              :key="item.roleId"
              :label="item.roleName"
              :value="item.roleName"
            ></el-option>
          </el-select>
        </div>
        <el-button type="primary" icon="el-icon-plus" class="addadmin" @click="addAdmin">添加管理员</el-button>
      </div>
      <el-table
        flex-1
        :data="tableData"
        :row-class-name="class_name"
        :header-cell-style="headerClass"
        :height="real_height + 'px'"
      >
        <el-table-column width="60">
          <template>
            <span></span>
          </template>
        </el-table-column>
        <el-table-column label="手机号" class="table_head" width="130">
          <template slot-scope="scope">
            <span class="table_content">{{ scope.row.mobile }}</span>
          </template>
        </el-table-column>
        <el-table-column label="用户名称" class="table_head" width="180">
          <template slot-scope="scope">
            <span class="table_content">{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="角色" class="table_head">
          <template slot-scope="scope">
            <span class="table_content">{{ scope.row.roleName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="上次登录时间" width="220" class="table_head">
          <template slot-scope="scope">
            <span class="table_content">{{ scope.row.loginTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="登录IP限制" class="table_head">
          <template slot-scope="scope">
            <span v-show="scope.row.limit ==0">不限制</span>
            <span v-show="scope.row.limit ==1">{{scope.row.count}}个可用IP</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑用户</el-button>
            <el-button
              type="text"
              size="mini"
              class="del_button"
              @click="handleDelete(scope.$index, scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <addadmin ref="addadmin" @getAdminFun="getAdminFun"></addadmin>
      <setuser v-on:setuser="getAdminFun" ref="setuser"></setuser>
    </el-card>
  </div>
</template>

<script>
import { getAdmin, getRole, deleteAdmin } from "../../api/index";
export default {
  components: {
    addadmin: () =>
      import(/* w  ebpackChunkName: "design" */ "./components/addAdmin"),
    setuser: () =>
      import(/* w  ebpackChunkName: "design" */ "./components/setuser")
  },
  data() {
    return {
      options: [],
      tableData: [],
      org_height: document.documentElement.clientHeight,
      real_height: document.documentElement.clientHeight - 170,
      timer: false,
      value: "全部"
    };
  },
  mounted() {
    this.real_height = this.org_height - 170;
    const that = this;
    window.addEventListener("resize", function() {
      that.org_height = document.documentElement.clientHeight;
    });
    this.getAdminFun();
    this.getRoleFun();
  },
  watch: {
    org_height(val) {
      if (!this.timer) {
        this.real_height = val - 170;
        this.timer = true;
        let that = this;
        setTimeout(function() {
          that.timer = false;
        }, 400);
      }
    }
  },
  methods: {
    class_name({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "popularLine";
      } else {
        return "colorLine";
      }
    },
    //table表头
    headerClass() {
      return "background-color:#FAFCFF;height:32px;padding:5px";
    },
    //获取角色方法
    getRoleFun() {
      getRole()
        .then(res => {
          this.options = res.data;
        })
        .catch(error => {});
    },
    select(v) {
      let data = {
        roleId: ""
      };
      getAdmin(data)
        // 判断显示角色
        .then(res => {
          if (v == "全部") {
            this.tableData = res.data;
          } else {
            this.tableData = res.data
              .filter(ele => ele.roleName == v)
              .map(ele => {
                return ele;
              });
          }
        });
    },
    //获取全部管理员方法
    getAdminFun() {
      let data = {
        roleId: ""
      };
      getAdmin(data)
        .then(res => {
          this.tableData = res.data;
        })
        .catch(error => {});
    },
    // 添加管理员组件初始化
    addAdmin() {
      this.$refs.addadmin.init();
    },
    // 修改管理员组件初始化
    handleEdit(id, data) {
      this.$refs.setuser.init(id, data);
    },
    handleDelete(id, adminData) {
      this.$confirm(
        " 删除之后此用户将无法再用担当账号登录本系统",
        "您确定要删除这个管理员吗?",
        {
          confirmButtonText: "确认删除",
          cancelButtonText: "取消",
          center: true
        }
      )
        .then(() => {
          let data = {
            userId: adminData.userId
          };
          deleteAdmin(data)
            .then(res => {
              this.getAdminFun();
              this.$message({
                type: "success",
                message: "删除成功!"
              });
            })
            .catch(error => {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@include admin;
</style>
